module.exports = __webpack_public_path__ + "assets/img/2021-midAutumn-btn1.924014b5.png";